import { type DataValue, NOT_FOUND } from '@netpurpose/types'
import { type BackendDataValue, parseUnitName } from '../../../models/dataValue'

export const parseImpactDataValue = (backendDataValue: BackendDataValue | null): DataValue => {
  if (backendDataValue === null) {
    return { unit: NOT_FOUND }
  }

  const [value, unit] = backendDataValue

  if (value === null) {
    return { unit: parseUnitName(unit) }
  }

  return { value, unit: parseUnitName(unit) }
}
